module.exports = __webpack_public_path__ + "static/roadmap-status-select-249e6b4eb8604d4cac85f942744dab05.png";